import { BaseBlock } from "./BaseBlock";

/**
 * Блок изображения.
 */
export class ImageBlock extends BaseBlock {

    constructor(
        private readonly src: string,
        private readonly alt: string,
        private readonly onOpen: (src: string) => void
    ) {
        super();
    }

    public override mount(): void {

        this.root = document.createElement("div");
        this.root.className = "task image-task";

        const image = document.createElement("img");

        image.src = this.src;
        image.alt = this.alt;
        image.style.cursor = "pointer";

        image.addEventListener(
            "click",
            () => this.onOpen(this.src)
        );

        this.root.appendChild(image);

    }

    public override update(): void {
    }

    public override unmount(): void {
        super.unmount();
    }

}